import { Injectable } from "@angular/core";
import { IModel } from "./model/imodel";
import { Route2 } from "./model/route2";
import { Intent } from "./model/intent";
import { SessionToken } from "./model/sessiontoken";
import { Schedule } from "./model/schedule";
import { RouteBooking } from "./model/routebooking";
import { Travel } from "./model/travel";
import { Response } from "./model/response";
import { AvailabilityQuery } from "./model/availabilityquery";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Rx";
import { FromJSONable } from "./model/FromJSONable";
import { environment } from "../environments/environment";
import { UrlWebPay } from "./model/url";
import { WebPay } from "./model/webpay";
import { Country } from "./model/country";
import { WebPayNotification } from "./model/WebPayNotification";
import { recaptcha } from "./model/recaptcha";
import {
  BookingRequest,
  BookingResponse,
  FindInvoiceRequest,
  FindInvoiceResponse,
  InvoiceFoundRequest, InvoiceFoundClass,InvoiceFoundResponse
} from "./bill/interfaces/booking.model";
import { BillingResponse,InvoiceActive, InvoiceActiveClass } from "./bill/interfaces/responses.model";
import {
  CFDI,
  CFDIClass,
  InvoiceRequest,
  RegimesClass,
  RegimesResponse,
} from "./bill/interfaces/regimes.model";
import {
  SuburbClass,
  SuburbResponse,
  ZipCodeClass,
  ZipCodeResponse,
} from "./bill/interfaces/zipcode.model";
import { TrainStop } from "./model/trainstop";

@Injectable()
export class ModelRestService implements IModel {
  constructor(private http: HttpClient) {}

  private train_stops = {};
  private route_by_name = {};

  private base: string = environment.restws_base;
  private prefix: string = "v1";
  stdCall<T>(
    cl: { new () },
    url: string,
    method: string = "get",
    data0 = null,
    params0 = {},
    headers0 = null,
    it: string = null,
    clarr: boolean = false
  ): Observable<Response<T>> {
    let obs: Observable<Response<T>> = new Observable((observer) => {
      var headers = {
        "X-Rch-At": "vXykLvyM7VmfGZLNYn3D",
      };
      if (headers0 != null) {
        for (var i in headers0) {
          let v = headers0[i];
          headers[i] = v;
        }
      }
      if (method == "get") {
        this.http
          .get<Response<T>>(url, { headers: headers, params: params0 })
          .subscribe(
            (data) => {
              observer.next(this.assign(data, cl, clarr));
            },
            (error) => {
              observer.error(error);
            }
          );
      } else if (method == "post") {
        this.http.post<Response<T>>(url, data0, { headers: headers }).subscribe(
          (data) => {
            observer.next(this.assign(data, cl, clarr));
          },
          (error) => {
            observer.error(error);
          }
        );
      } else if (method == "put") {
        this.http.put<Response<T>>(url, data0, { headers: headers }).subscribe(
          (data) => {
            observer.next(this.assign(data, cl, clarr));
          },
          (error) => {
            observer.error(error);
          }
        );
      }
    });
    return obs;
  }
  assign<T>(data, cl: { new () } = null, clarry: boolean): Response<T> {
    var r: Response<T> = new Response<T>(null, null, clarry ? [] : new cl());
    if (clarry) {
      r.parseJSONObject2(data, cl);
    } else {
      r.parseJSONObject(data);
    }
    return r;
  }

  getRoute(route: string): Observable<Response<Route2>> {
    return this.stdCall<Route2>(
      Route2,
      this.base + "/" + this.prefix + "/routes/" + route,
      "get",
      null,
      {}
    );
  }

  public getRouteByName(route_name: string): Route2 {
    return this.route_by_name[route_name];
  }

  public getTrainStopById(id: number): TrainStop {
    let ts: TrainStop = this.train_stops[id];
    return ts;
  }

  getIsValidRecaptcha(tokenRecaptcha: string): Observable<Response<recaptcha>> {
    return this.stdCall<recaptcha>(
      recaptcha,
      this.base + "/" + this.prefix + "/validrecaptcha",
      "get",
      null,
      {},
      { "Token-Recaptcha": tokenRecaptcha }
    );
  }
  createIntent(type: string): Observable<Response<Intent>> {
    return this.stdCall<Intent>(
      Intent,
      this.base + "/" + this.prefix + "/intent/" + type,
      "post"
    );
  }
  createSession(): Observable<Response<SessionToken>> {
    return this.stdCall<SessionToken>(
      SessionToken,
      this.base + "/" + this.prefix + "/session",
      "post",
      null,
      {},
      null,
      "create-session"
    );
  }
  getRouteScheduleAvailable(
    id: number,
    query: AvailabilityQuery
  ): Observable<Response<Schedule>> {
    return this.stdCall<Schedule>(
      Schedule,
      this.base + "/" + this.prefix + "/routes/" + id + "/schedule/available",
      "get",
      null,
      query.getForParams()
    );
  }
  saveRouteBooking(b: RouteBooking): Observable<Response<RouteBooking>> {
    return this.stdCall<RouteBooking>(
      RouteBooking,
      this.base + "/" + this.prefix + "/routes/booking",
      "post",
      b,
      {},
      null,
      "put-booking"
    );
  }
  paymentinforef(
    id: string,
    monto: string
  ): Observable<Response<RouteBooking>> {
    return this.stdCall<RouteBooking>(
      RouteBooking,
      this.base + "/" + this.prefix + "/paymentinforef/" + id + "/" + monto,
      "get",
      null,
      {},
      null,
      null
    );
  }
  paymentinfo(id: string): Observable<Response<RouteBooking>> {
    return this.stdCall<RouteBooking>(
      RouteBooking,
      this.base + "/" + this.prefix + "/paymentinfo/" + id,
      "get",
      null,
      {},
      null,
      null
    );
  }
  paymentinfoPixel(id: string): Observable<Response<RouteBooking>> {
    return this.stdCall<RouteBooking>(
      RouteBooking,
      this.base + "/" + this.prefix + "/paymentinfoPixel/" + id,
      "get",
      null,
      {},
      null,
      null
    );
  }
  payresponse(id: string): Observable<Response<WebPay>> {
    return this.stdCall<WebPay>(
      WebPay,
      this.base + "/" + this.prefix + "/payresponse/" + id,
      "get",
      null,
      {},
      null,
      null
    );
  }
  payresponseref(id: string, monto: string): Observable<Response<WebPay>> {
    return this.stdCall<WebPay>(
      WebPay,
      this.base + "/" + this.prefix + "/payresponseref/" + id + "/" + monto,
      "get",
      null,
      {},
      null,
      null
    );
  }
  getWebPayUrl(b: RouteBooking): Observable<Response<WebPay>> {
    return this.stdCall<WebPay>(
      WebPay,
      this.base + "/" + this.prefix + "/routes/booking",
      "post",
      b,
      {},
      null,
      "put-booking"
    );
  }
  getTravel(
    id: number,
    id_src: number,
    id_dst: number,
    passenger: number,
    id_class: number
  ): Observable<Response<Travel>> {
    return this.stdCall<Travel>(
      Travel,
      this.base + "/" + this.prefix + "/travel/" + id,
      "get",
      null,
      {
        src: id_src,
        dst: id_dst,
        passenger: passenger,
        c: id_class,
      }
    );
  }
  getCountries(): Observable<Response<Country[]>> {
    return this.stdCall<Country[]>(
      Country,
      this.base + "/" + this.prefix + "/countries",
      "get",
      null,
      {},
      null,
      null,
      true
    );
  }
  getPaymentNotification(
    reference: number
  ): Observable<Response<WebPayNotification>> {
    return this.stdCall<WebPayNotification>(
      WebPayNotification,
      this.base + "/" + this.prefix + "/payment/notification/" + reference,
      "get",
      null
    );
  }
  getBooking(
    bookingRequest: BookingRequest
  ): Observable<Response<RouteBooking>> {
    return this.stdCall<RouteBooking>(
      RouteBooking,
      this.base +
        "/" +
        this.prefix +
        "/invoice/booking/" +
        bookingRequest.clave +
        "/" +
        bookingRequest.fecha
    );
  }
  getRegimes(): Observable<Response<RegimesResponse>> {
    return this.stdCall<RegimesResponse>(
      RegimesClass,
      this.base + "/" + this.prefix + "/address/regimes"
    );
  }
  getCFDIs(regime: string): Observable<Response<CFDIClass>> {
    return this.stdCall<CFDIClass>(
      CFDIClass,
      this.base + "/" + this.prefix + `/cfdis/${regime}`
    );
  }
  postInvoice(invoiceRequest: InvoiceRequest): Observable<Response<any>> {
    return this.stdCall<Response<any>>(
      CFDIClass,
      this.base + "/" + this.prefix + `/invoice/request`,
      "post",
      invoiceRequest
    );
  }
  postFileSAT(rfc: string, file: File): Observable<Response<any>> {
    const formData = new FormData();
    formData.append(file.name, file);
    return this.stdCall<Response<any>>(
      CFDIClass,
      this.base + "/" + this.prefix + `/invoice/uploadFileSAT/${rfc}`,
      "post",
      formData
    );
  }
  getAddress(zipcode: string): Observable<Response<ZipCodeResponse>> {
    return this.stdCall<ZipCodeResponse>(
      ZipCodeClass,
      this.base + "/" + this.prefix + `/address/zipcode/${zipcode}`
    );
  }
  getSuburb(zipcode: string): Observable<Response<SuburbClass>> {
    return this.stdCall<SuburbClass>(
      SuburbClass,
      this.base + "/" + this.prefix + `/address/suburb/${zipcode}`
    );
  }
  postFindInvoice(invoiceRequest: FindInvoiceRequest): Observable<Response<any>> {
    return this.stdCall<Response<any>>(
      FindInvoiceResponse,
      this.base + "/" + this.prefix + `/invoice/find`,
      "post",
      invoiceRequest
    );
  }

  getCheckInvoiceRequestStatus(): Observable<Response<InvoiceActive>> {
    return this.stdCall<InvoiceActive>(
      InvoiceActiveClass,
      this.base + "/" + this.prefix + "/invoice/isRequestActive",
      "get",
      null,
      {},
      null,
      null,
      false
    );
  }
   
}
